/**
 * EPIC DXC strings, English.
 *
 * `ar` is the fallback, so a key missing here renders the Arabic rather than
 * the raw key. Every key is still translated: a half-English screen is worse
 * than a consistent one.
 */
export const diagnosticCasesEn: Record<string, string> = {
  'nav.diagnosticCases': 'Diagnostic cases',
  'dxc.title': 'Diagnostic cases',
  'dxc.subtitle':
    'Patients here for tests only — by external referral or walk-in, with no doctor visit',
  'dxc.new': 'New diagnostic case',
  'dxc.empty': 'No diagnostic cases',
  'dxc.emptyBody':
    'Start a new case when a patient arrives for tests without a doctor appointment.',
  'dxc.searchPlaceholder': 'Case number, patient name or MRN…',
  'dxc.status.NEW': 'New',
  'dxc.status.IN_PROGRESS': 'In progress',
  'dxc.status.RESULTS_READY': 'Results ready',
  'dxc.status.COMPLETED': 'Delivered',
  'dxc.status.CANCELLED': 'Cancelled',
  'dxc.source.WALK_IN': 'Walk-in',
  'dxc.source.EXTERNAL_REFERRAL': 'External referral',
  'dxc.column.caseNumber': 'Case number',
  'dxc.column.patient': 'Patient',
  'dxc.column.source': 'Source',
  'dxc.column.orders': 'Orders',
  'dxc.column.status': 'Status',
  'dxc.column.opened': 'Opened',
  'dxc.label.referringDoctor': 'Referring doctor',
  'dxc.label.facility': 'Referring facility',
  'dxc.label.referralNumber': 'Referral number',
  'dxc.label.indication': 'Clinical indication',
  'dxc.label.notes': 'Administrative notes',
  'dxc.label.lab': 'Laboratory',
  'dxc.label.imaging': 'Imaging',
  'dxc.label.mrn': 'MRN',
  'dxc.label.branch': 'Branch',
  'dxc.wizard.title': 'New diagnostic case',
  'dxc.wizard.step.patient': 'Patient',
  'dxc.wizard.step.source': 'Source and referral',
  'dxc.wizard.step.services': 'Tests',
  'dxc.wizard.step.confirm': 'Review and confirm',
  'dxc.wizard.searchPatient': 'Search for the patient',
  'dxc.wizard.searchPatientHint': 'By name, MRN or phone number',
  'dxc.wizard.registerPatient': 'Register a new patient',
  'dxc.wizard.selectedPatient': 'Selected patient',
  'dxc.wizard.change': 'Change',
  'dxc.wizard.searchProvider': 'Search for the referring doctor',
  'dxc.wizard.newProvider': 'Add a referring doctor',
  'dxc.wizard.providerName': 'Doctor name',
  'dxc.wizard.providerSpecialty': 'Specialty',
  'dxc.wizard.providerFacility': 'Facility / hospital',
  'dxc.wizard.providerPhone': 'Phone',
  'dxc.wizard.saveProvider': 'Save doctor',
  'dxc.wizard.noProvider': 'No referring doctor',
  'dxc.wizard.labTests': 'Laboratory tests',
  'dxc.wizard.searchTests': 'Search the test catalogue',
  'dxc.wizard.selectedTests': 'Selected: {count}',
  'dxc.wizard.imagingStudies': 'Imaging studies',
  'dxc.wizard.addStudy': 'Add an imaging study',
  'dxc.wizard.modality': 'Modality',
  'dxc.wizard.bodyRegion': 'Body region',
  'dxc.wizard.remove': 'Remove',
  'dxc.wizard.back': 'Back',
  'dxc.wizard.next': 'Next',
  'dxc.wizard.submit': 'Create case',
  'dxc.wizard.needsWork': 'Choose at least one laboratory or imaging test.',
  'dxc.wizard.needsPatient': 'Choose the patient first.',
  'dxc.wizard.created': 'Case {number} created',
  'dxc.wizard.createdBody': 'The orders now appear on the laboratory and imaging worklists.',
  'dxc.wizard.openCase': 'Open the case',
  'dxc.wizard.panel': 'Panel',
  'dxc.detail.orders': 'Orders',
  'dxc.detail.noOrders': 'No orders',
  'dxc.detail.finance': 'Finance',
  'dxc.detail.noInvoice': 'No invoice issued yet',
  'dxc.detail.invoiceTotal': 'Total',
  'dxc.detail.invoicePaid': 'Paid',
  'dxc.detail.invoiceBalance': 'Outstanding',
  'dxc.detail.checkout': 'Issue invoice and collect',
  'dxc.detail.print': 'Print case report',
  'dxc.detail.complete': 'Hand over results',
  'dxc.detail.cancel': 'Cancel case',
  'dxc.detail.cancelReason': 'Reason for cancelling',
  'dxc.detail.confirmCancel': 'Confirm cancellation',
  'dxc.detail.completeHint': 'Available once every result is approved',
  'dxc.detail.pending': 'Awaiting approval: {orders}',
  'dxc.detail.result': 'Result',
  'dxc.detail.reference': 'Reference range',
  'dxc.detail.awaitingResult': 'Awaiting result',
  'dxc.detail.abnormal': 'Out of range',
  'dxc.detail.critical': 'Critical',
  'dxc.detail.reportFinal': 'Report approved',
  'dxc.detail.reportAmended': 'Report amended',
  'dxc.detail.reportPending': 'Report in progress',
  'dxc.checkout.title': 'Diagnostic case checkout',
  'dxc.checkout.nothingToBill': 'Every order is already invoiced',
  'dxc.checkout.total': 'Total',
  'dxc.checkout.method': 'Payment method',
  'dxc.checkout.amount': 'Amount received',
  'dxc.checkout.collect': 'Collect',
  'dxc.checkout.issueUnpaid': 'Issue invoice with a balance owing',
  'dxc.checkout.done': 'Invoice {number} issued',
  'dxc.checkout.receipt': 'Receipt {number}',
  'dxc.checkout.unpricedHint':
    'An imaging study with no priced service cannot be invoiced. Add a service for it under Services and prices.',
  'dxc.origin.visit': 'Visit',
  'dxc.origin.case': 'Diagnostic case',
  'dxc.origin.none': 'Direct order',
  'dxc.origin.caseTooltip': 'Ordered from a diagnostic case — there is no doctor visit',
};
